import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'filerApproved' })
export class AcceptStatusPipe implements PipeTransform {
    transform(value, args: any): any {
        this.filterValues(value, args);
    }
    filterValues(value, args) {
        let values = [], count = 0;
        _.each(value, field => {
            ++count;
            if (field.acceptStatus == args) {
                values.push(field);
            }
        })
        if (count == value.length) {
            return values.length > 0 ? values : [];
        }
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/pipesFiles/listApproved.pipe.ts